import React from 'react'
import { Colors } from '../../../constants/colors'
import { BaseIconProps } from '../types'

const ComplianceAnnouncementIcon = ({ color = Colors.N100, size = 24 }: BaseIconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" data-testid="compliance-announcement-icon">
    <circle cx="12.0044" cy="12" r="12" fill="#003A7F" />
    <path
      d="M17.3376 9.66659V8.13799C17.3376 8.04958 17.3024 7.9648 17.2399 7.90229L16.0042 6.66659L14.7685 5.43088C14.706 5.36837 14.6212 5.33325 14.5328 5.33325H7.00423C6.82014 5.33325 6.6709 5.48249 6.6709 5.66658V18.3333C6.6709 18.5173 6.82014 18.6666 7.00423 18.6666H17.0042C17.1883 18.6666 17.3376 18.5173 17.3376 18.3333V17.6666"
      stroke={color}
      strokeWidth="0.886667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.6711 16.3333C18.1438 16.3333 19.3377 15.1394 19.3377 13.6667C19.3377 12.1939 18.1438 11 16.6711 11C15.1983 11 14.0044 12.1939 14.0044 13.6667C14.0044 15.1394 15.1983 16.3333 16.6711 16.3333Z"
      stroke={color}
      strokeWidth="0.886667"
    />
    <path
      d="M15.4705 13.8668L16.1372 14.5919L16.7366 14.013L17.8038 12.9458"
      stroke={color}
      strokeWidth="0.886667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ComplianceAnnouncementIcon
